import React, { Fragment, useState, useEffect } from "react";
import {
  Card,
  FormGroup,
  Label,
  Input,
  Form,
  FormFeedback,
  Button,
  Row,
  Col,
  Container,
} from "reactstrap";
import { useParams } from "react-router-dom";
import {
  DOG_CATEGORY_ANSWER,
  DOG_REQUIRED_DOCUMENT_ANSWERS,
  UPDATE_LICENSE_STATUS,
  UPLOAD_FILE,
  USER_CHOOSE_PLAN,
} from "../../../constants/ApiPaths";
import API from "../../../redux/actions/API";
import { useDispatch, useSelector } from "react-redux";
import { END_USER_DETAILS_SUCCESS } from "../../../redux/actions/ActionTypes";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import { useFormik } from "formik";

import YupSchemaCreator from "../../Agency/Template/YupSchemaCreator";
import * as Yup from "yup";
import {
  authCustomerHeader,
} from "../../../functions/CoreFunctions";

export const InputField = (props) => {
  const { handlechange, values = {},  formik } = props;
  const { uniqueId, placeholder = "", label = "" } = props.data || {};
  const { errors = {}, touched = {}, handleBlur } = formik;
  return (
    <Col md={4} key={uniqueId}>
      <FormGroup>
        <Label for={uniqueId}>{label}</Label>
        <Input
          onChange={handlechange}
          value={values[uniqueId]}
          type="text"
          name={uniqueId}
          id={uniqueId}
          onBlur={handleBlur}
          invalid={touched[uniqueId] && errors[uniqueId]}
          placeholder={placeholder}
        />
        <FormFeedback>
          {touched[uniqueId] && errors[uniqueId] && (
            <div>{errors[uniqueId]}</div>
          )}
        </FormFeedback>
      </FormGroup>
    </Col>
  );
};

export const TextAreaField = (props) => {
  const { handlechange, values = {},  formik } = props;
  const { uniqueId, placeholder = "", label = "" } = props.data || {};
  const { errors = {}, touched = {}, handleBlur } = formik;

  return (
    <Col md={4} key={uniqueId}>
      <FormGroup>
        <Label for={uniqueId}>{label}</Label>
        <Input
          value={values[uniqueId]}
          onChange={handlechange}
          type="textarea"
          name={uniqueId}
          id={uniqueId}
          onBlur={handleBlur}
          invalid={touched[uniqueId] && errors[uniqueId]}
          placeholder={placeholder}
        />
        <FormFeedback>
          {touched[uniqueId] && errors[uniqueId] && (
            <div>{errors[uniqueId]}</div>
          )}
        </FormFeedback>
      </FormGroup>
    </Col>
  );
};
export const FileUploadField = (props) => {
  const {  values = {},  formik } = props;
  const {
    licenseRequiredDocId,
    documentName = "",
    documentDescription = "",
  } = props.data || {};
  const [editable, seteditable] = useState(true);
  // const [DocId, setDocId] = useState("");
  const handleFileUpload = async (e) => {
    e.preventDefault();
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const formDat = new FormData();
      formDat.append("file", selectedFile);
      const config = {
        method: "POST",
        url: UPLOAD_FILE,
        data: formDat,
      };
      try {
        const response = await API(config);
        const { status, filePath } = response.data;
        if (status === "Success") {
          formik.setFieldValue(licenseRequiredDocId, filePath);
        }
      } catch (error) {
        console.error(error);
      } finally {
      }
    }
  };

  const Editdocument = (e) => {
    // const Docid = e.currentTarget.dataset.licenserequireddocid;
    // setDocId(Docid);
    seteditable(false);
  };

  const DeleteDocumet = (e) => {
    // const Docid = e.currentTarget.dataset.licenserequireddocid;
    seteditable(true);
  };

  return (
    <Col md={4} key={licenseRequiredDocId}>
      <FormGroup>
        {values[licenseRequiredDocId] && editable ? (
          <a
            href={values[licenseRequiredDocId]}
            style={{ cursor: "pointer" }}
            target="_blank"
            rel="noreferrer noopener"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="#1b3e6f6b"
              stroke="#fff"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M14 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8l-6-6z" />
              <path d="M14 3v5h5M16 13H8M16 17H8M10 9H8" />
            </svg>
            <Label></Label>
          </a>
        ) : (
          <>
            <Label for={licenseRequiredDocId}>{documentName}</Label>
            <Input
              // value={values[licenseRequiredDocId]}
              onChange={handleFileUpload}
              type="file"
              name={licenseRequiredDocId}
              id={licenseRequiredDocId}
              placeholder={documentDescription}
            />
          </>
        )}
      </FormGroup>
      {editable && (
        <Button
          color="primary"
          onClick={Editdocument}
          data-licenserequireddocid={licenseRequiredDocId}
        >
          Edit
        </Button>
      )}
      {!editable && (
        <Button
          color="danger"
          onClick={DeleteDocumet}
          data-licenserequireddocid={licenseRequiredDocId}
        >
          Delete
        </Button>
      )}
    </Col>
  );
};

export const DateField = (props) => {
  const { handlechange, values = {},  formik } = props;
  const { uniqueId, label = "" } = props.data || {};
  const { errors = {}, touched = {}, handleBlur } = formik;

  return (
    <Col md={4} key={uniqueId}>
      <FormGroup>
        <Label for={uniqueId}>{label}</Label>
        <Input
          type="date"
          value={values[uniqueId]}
          onChange={handlechange}
          name={uniqueId}
          id={uniqueId}
          onBlur={handleBlur}
          invalid={touched[uniqueId] && errors[uniqueId]}
        />
        <FormFeedback>
          {touched[uniqueId] && errors[uniqueId] && (
            <div>{errors[uniqueId]}</div>
          )}
        </FormFeedback>
      </FormGroup>
    </Col>
  );
};

export const TimeField = (props) => {
  const { handlechange, values = {},  formik } = props;
  const { uniqueId, label = "" } = props.data || {};
  const { errors = {}, touched = {}, handleBlur } = formik;

  return (
    <Col md={4} key={uniqueId}>
      <FormGroup>
        <Label for={uniqueId}>{label}</Label>
        <Input
          type="time"
          onBlur={handleBlur}
          invalid={touched[uniqueId] && errors[uniqueId]}
          value={values[uniqueId]}
          onChange={handlechange}
          name={uniqueId}
          id={uniqueId}
        />
        <FormFeedback>
          {touched[uniqueId] && errors[uniqueId] && (
            <div>{errors[uniqueId]}</div>
          )}
        </FormFeedback>
      </FormGroup>
    </Col>
  );
};

export const SelectField = (props) => {
  const { handlechange, values = {},  formik } = props;
  const {
    type,
    uniqueId,
    placeholder = "",
    options = [],
    label = "",
    isMandatory = "",
  } = props.data || {};
  const { errors = {}, touched = {}, handleBlur } = formik;

  return (
    <Col md={4} key={uniqueId}>
      <FormGroup>
        <Label for={uniqueId}>
          {isMandatory === true ? `${label} *` : label}
        </Label>
        <Input
          type={type}
          onChange={handlechange}
          value={values[uniqueId]}
          id={uniqueId}
          name={uniqueId}
          onBlur={handleBlur}
          invalid={touched[uniqueId] && errors[uniqueId]}
          placeholder={placeholder}
        >
          <option>Please Select</option>
          {options.map((o) => (
            <option value={o.value} key={o.value}>
              {o.value}
            </option>
          ))}
        </Input>
        <FormFeedback>
          {touched[uniqueId] && errors[uniqueId] && (
            <div>{errors[uniqueId]}</div>
          )}
        </FormFeedback>
      </FormGroup>
    </Col>
  );
};

export const CheckboxField = (props) => {
  const { handlechange,  formik } = props;
  const { uniqueId, options = [], label = "" } = props.data || {};
  const { errors = {}, touched = {}, handleBlur } = formik;

  return (
    <Col md={4} key={uniqueId}>
      <FormGroup>
        <Label>{label}</Label>
        {options.map((o) => (
          <Col key={o.optionUniqueId} sm={10}>
            <FormGroup check>
              <Label check>
                <Input
                  onChange={handlechange}
                  value={o.value}
                  onBlur={handleBlur}
                  type="checkbox"
                  name={uniqueId}
                />{" "}
                {o.label} &nbsp;
              </Label>
            </FormGroup>
          </Col>
        ))}
        {touched[uniqueId] && errors[uniqueId] && (
          <div>
            <small style={{ color: "#dc3545" }}>Required</small>
          </div>
        )}
      </FormGroup>
    </Col>
  );
};

export const RadioField = (props) => {
  const { handlechange, formik } = props;
  const { uniqueId, options = [], label = "" } = props.data || {};
  const { errors = {}, touched = {}, handleBlur } = formik;

  return (
    <Col md={4} key={uniqueId}>
      <FormGroup>
        <Label>{label}</Label>
        {options.map((o) => (
          <Col key={o.optionUniqueId} sm={10}>
            <FormGroup check>
              <Label check>
                <Input
                  onBlur={handleBlur}
                  onChange={handlechange}
                  type="radio"
                  key={o.optionUniqueId}
                  value={o.value}
                  name={uniqueId}
                />{" "}
                {o.label} &nbsp;
              </Label>
            </FormGroup>
          </Col>
        ))}
        {touched[uniqueId] && errors[uniqueId] && (
          <div>
            <small style={{ color: "#dc3545" }}>Required</small>
          </div>
        )}
      </FormGroup>
    </Col>
  );
};

export const DynamicField = (props) => {
  const fieldTypes = {
    text: InputField,
    textarea: TextAreaField,
    date: DateField,
    select: SelectField,
    radio: RadioField,
    time: TimeField,
    checkbox: CheckboxField,
  };
  const { data, handlechange, previewMode, values, formik } = props;
  const Field = fieldTypes[props?.data?.type] || InputField;
  return (
    <Field
      data={data}
      handlechange={handlechange}
      formik={formik}
      values={values}
      previewMode={previewMode}
    />
  );
};

export const BackButton = (props) => {
  const { handlePress = () => {} } = props;
  return (
    <div className="top-btn">
      <Button onClick={handlePress} color="primary">
        {" "}
        <svg
          className="mr-3"
          xmlns="http://www.w3.org/2000/svg"
          width="10.977"
          height="7.321"
          viewBox="0 0 10.977 7.321"
        >
          <path
            id="Icon_ionic-ios-arrow-round-back"
            data-name="Icon ionic-ios-arrow-round-back"
            d="M11.859,11.392a.5.5,0,0,1,0,.7L9.548,14.415h8.819a.5.5,0,0,1,0,.991H9.548l2.318,2.322a.5.5,0,0,1,0,.7.494.494,0,0,1-.7,0L8.023,15.262h0a.557.557,0,0,1-.1-.156.473.473,0,0,1-.038-.191.5.5,0,0,1,.141-.347L11.165,11.4A.486.486,0,0,1,11.859,11.392Z"
            transform="translate(-7.882 -11.252)"
            fill="#fff"
          />
        </svg>
        Back
      </Button>
    </div>
  );
};

const ReuploadFormValue = (props) => {
  const [answers, setAnswers] = useState({});
  const [validationSchema, setValidationSchema] = useState({});
  const [loading, setLoading] = useState(false);
  const previewMode=false
  const dispatch = useDispatch();
  let { licensePlanId, dogLicenseId } = useParams();
  const {
    licenseRequiredDocDetails = [],
    categoryDetails = [],
  } = useSelector((state) => state.CustomerFormReducer);

  const handleFormSubmit = async (values) => {
    setLoading(true);

    try {
      let temp = {};

      props.categoryData.forEach((e) => {
        temp[`cat_id_${e.categoryId}`] = e.categoryAnswerId;
      });

      let createLicenseData = {
        dogLicenseId: dogLicenseId,
        categoryDetails: categoryDetails.map((cat) => {
          let catAnswer = { ...cat };
          catAnswer["categoryPlaceHolder"] = cat.categoryPlaceHolder.map(
            (catPlaceHolder) => {
              return {
                ...catPlaceHolder,
                selectedAnswer: values[catPlaceHolder.uniqueId],
              };
            }
          );
          return {
            categoryAnswerId: temp[`cat_id_${cat.categoryId}`],
            categoryId: cat.categoryId,
            categoryAnswer: JSON.stringify(catAnswer),
          };
        }),
      };

      let createLicenseConfig = {
        method: "POST",
        url: DOG_CATEGORY_ANSWER,
        headers: authCustomerHeader(),
        data: createLicenseData,
      };

      const documentDetails = props.document.map((e) => {
        return {
          licenseRequiredDocDetailsId: e.licenseRequiredDocDetailsId,
          licenseRequiredDocId: e.licenseRequiredDocId,
          filePath: values[e.licenseRequiredDocId],
          documentValidFrom: "",
          documentValidTo: "",
          categoryId: e.categoryid,
        };
      });
      let requiredDocConfig = {
        method: "POST",
        url: DOG_REQUIRED_DOCUMENT_ANSWERS,
        headers: authCustomerHeader(),
        data: {
          dogId: props.dogId,
          dogLicenseId: dogLicenseId,
          documentDetails: documentDetails,
        },
      };
      const config = {
        method: "PUT",
        url: UPDATE_LICENSE_STATUS,
        headers: authCustomerHeader(),
        data: {
          dogLicenseId: dogLicenseId,
          licenseStatus: "Pending",
          licensePlanId: licensePlanId,
        },
      };

      await API(config);

      await API(createLicenseConfig);
      await API(requiredDocConfig);
      setLoading(false);
      props.sucesscallback();
    } catch (error) {
      console.error(error);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: answers,
    validationSchema: validationSchema,
    onSubmit: handleFormSubmit,
  });

  const {
    handleSubmit,
    handleChange,
    values = {},
    
  } = formik;



  const fetchStateForm = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: USER_CHOOSE_PLAN,
      params: {
        licensePlanId: licensePlanId,
      },
    };
    try {
      const response = await API(config);
      const { status } = response.data;
      if (status === "Success") {
        const { licensePlanData } = response.data;
        dispatch({
          type: END_USER_DETAILS_SUCCESS,
          payload: licensePlanData,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStateForm();
  }, []);

  useEffect(() => {
    let questions = [];
    categoryDetails.forEach((e) => {
      questions.push(...e.categoryPlaceHolder);
    });

    questions = questions.filter((e) => e.isMandatory);
    questions = questions.map((question) => {
      if (question.type === "checkbox") {
        question.validationType = "array";
        question.validations = [
          {
            type: "min",
            params: [1], // at least one checkbox should be selected
          },
        ];
      }
      return question;
    });
    const yupSchema = questions.reduce(YupSchemaCreator, {});
    const schema = Yup.object().shape(yupSchema);

    setValidationSchema(schema);
  }, [answers]);

  useEffect(() => {
    let answers = {};
    props.Answer.forEach(({ categoryPlaceHolder = [] }) => {
      categoryPlaceHolder.forEach(({ uniqueId, type, selectedAnswer }) => {
        if (!uniqueId) return;
        answers[uniqueId] = type === "checkbox" ? [] : selectedAnswer;
      });
    });
    props.document.forEach((e) => {
      answers[e.licenseRequiredDocId] = e.filePath;
    });
    setAnswers(answers);
  }, [props.Answer, props.document]);

  if (loading) {
    return <CustomPageLoading />;
  }

  return (
    <div>
      <Container style={{ paddingBottom: "30px" }}>
        <Card body className="mt-4">
          <Form form="true" id="endUserLicenseForm" onSubmit={handleSubmit}>
            {categoryDetails.map((e) => {
              const categoryDocs = licenseRequiredDocDetails.filter(
                (doc) => doc.categoryid === e.categoryId
              );
              return (
                <Fragment key={e.categoryId}>
                  <div className="category-title">
                    <h4>{e.categoryName}</h4>
                  </div>
                  <div>
                    <Row>
                      {e.categoryPlaceHolder.map((field) => {
                        return (
                          <Fragment key={field.uniqueId}>
                            <DynamicField
                              handlechange={handleChange}
                              formik={formik}
                              values={values}
                              previewMode={previewMode}
                              data={field}
                            />
                          </Fragment>
                        );
                      })}
                    </Row>
                    {!!categoryDocs.length && (
                      <>
                        <div className="category-documents">
                          <h6>Additional Documents</h6>
                        </div>
                        <Row>
                          {categoryDocs.map((doc) => (
                            <Fragment>
                              <FileUploadField
                                sucesscallback={props.sucesscallback}
                                values={values}
                                data={doc}
                                formik={formik}
                              />
                            </Fragment>
                          ))}
                        </Row>
                      </>
                    )}
                  </div>
                </Fragment>
              );
            })}
          </Form>
          <div className="centerFlexRow">
            <Button form="endUserLicenseForm" type="submit" color="primary">
              Upload
            </Button>
          </div>
        </Card>
      </Container>
    </div>
  );
};

export default ReuploadFormValue;
